// extracted by mini-css-extract-plugin
export default {"footerMenuList":"FooterMenuList_footerMenuList__yBg46","button":"FooterMenuList_button__MCm4y"};